var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeRedClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#DD0071"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8215 28.8221C29.4724 28.1713 30.5277 28.1713 31.1786 28.8221L40 37.6436L48.8215 28.8221C49.4724 28.1713 50.5277 28.1713 51.1786 28.8221C51.8294 29.473 51.8294 30.5283 51.1786 31.1792L42.3571 40.0007L51.1786 48.8221C51.8294 49.473 51.8294 50.5283 51.1786 51.1792C50.5277 51.83 49.4724 51.83 48.8215 51.1792L40 42.3577L31.1786 51.1792C30.5277 51.83 29.4724 51.83 28.8215 51.1792C28.1707 50.5283 28.1707 49.473 28.8215 48.8221L37.643 40.0007L28.8215 31.1792C28.1707 30.5283 28.1707 29.473 28.8215 28.8221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeRedClose);
export default __webpack_public_path__ + "static/media/large_red_close.e8a124f993f0b60b50481441f1801060.svg";
export { ForwardRef as ReactComponent };